import angular from 'angular';
import authorComponent from './author.component';
import 'angular-filesize-filter/angular-filesize-filter';
import fancyBoxModule from '../../../modules/fancybox-plus/fancybox-plus';
import imageFallbackDirective from './image-fallback.directive';

let authorModule = angular.module('author', [
    fancyBoxModule,
    'ngFilesizeFilter'
])

    .component('author', authorComponent)
    .directive('imageFallback', imageFallbackDirective)
    .name;

let states = [
    {
        'name': 'author',
        'url': '/author/{id}',
        'component': 'author',
        'resolve': {
            'author': (AuthorAPI,$stateParams) => {
                "ngInject";
                return AuthorAPI.one($stateParams.id).get().then(
                    (author) => {
                        return author;
                    }
                );
            }
        }
    }
];

export default {name: authorModule, states: states};



// WEBPACK FOOTER //
// ./src/app/components/page/author/author.js